import { atom } from "recoil";

const prefix = "tingwu-transcription";

export const composingDataState = atom({
  key: `${prefix}/composingDataState`,
  default: "",
});
